<template>
<div class="archive">
    <div v-if="popShown" id="s-f-m-a" class="modal fade show scrollableHorizontal" data-backdrop="true" style="display: block;">
        <div class="popup popup-w1 fade-down-big">
            <div class="modal-content">
                <div class="main-block form_block">
                    <a class="form_close" @click="hidePop">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 1L1 17" stroke="#2C2A44" stroke-width="2"></path>
                            <path d="M1 1L17 17" stroke="#2C2A44" stroke-width="2"></path>
                        </svg>
                    </a>
                    <h2 class="form_title">Архів погоди</h2>
                    <div class="sim_table">
                        <div class="container-fluid">
                            <div>
                                <div class="text-left mb-3">
                                    <h4>Спека</h4>
                                    <div class="limit_index_label">Температура: </div>
                                    <b>вище ніж {{ heatTemperatureLimit }} ℃ більше ніж {{ heatDaysLimit }} дні</b><br>
                                </div>
                                <table class="table table-bordered table-responsive tableWeatherData">
                                    <thead>
                                    <tr class="color_table">
                                        <th><span><sub>День</sub>\<sup>Рік</sup></span></th>
                                        <th v-for="year in years">{{ year }}</th>
                                    </tr>
                                    <tr class="">
                                        <th class="color_table">Днів спеки</th>
                                        <th v-for="heatDaysPerYear in heatDaysCount" v-bind:class="{
                                            color_heat_total: heatDaysPerYear >= heatDaysLimit,
                                            color_totals: heatDaysPerYear < heatDaysLimit
                                        }">{{ heatDaysPerYear }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(dataPerPeriod, key) in preparedHistoricalData()">
                                        <td class="color_table"> {{ key }} </td>
                                        <td v-for="dataPerYear in dataPerPeriod" v-bind:class="{color_heat: dataPerYear.heat > heatTemperatureLimit}">{{ Number(dataPerYear.heat).toFixed(2) }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="my-4"></div>
                            <div>
                                <div class="text-left mb-3">
                                    <h4>Опади</h4>
                                    <b>менше ніж {{ draughtRainLimit }} мм або більше ніж {{ xRainLimit }} мм</b>
                                </div>
                                <table class="table table-bordered table-responsive tableWeatherData">
                                    <thead>
                                    <tr class="color_table">
                                        <th><span><sub>День</sub>\<sup>Рік</sup></span></th>
                                        <th v-for="year in years">{{ year }}</th>
                                    </tr>
                                    <tr class="">
                                        <th class="color_table">Загалом</th>
                                        <th v-for="precipitationAmountPerYear in precipitationAmount" v-bind:class="{
                                            color_draught_more: precipitationAmountPerYear > xRainLimit,
                                            color_draught_less: precipitationAmountPerYear < draughtRainLimit,
                                            color_totals: precipitationAmountPerYear < xRainLimit && precipitationAmountPerYear > draughtRainLimit
                                        }">{{ precipitationAmountPerYear > 0 ? Number(precipitationAmountPerYear).toFixed(2) : 0 }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(dataPerPeriod, key) in preparedHistoricalData()">
                                        <td class="color_table"> {{ key }} </td>
                                        <td v-for="dataPerYear in dataPerPeriod" v-bind:class="{color_draught: dataPerYear.precipitation > draughtRainLimit}">{{ dataPerYear.precipitation > 0 ? Number(dataPerYear.precipitation).toFixed(2) : 0 }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="form_item-button"><a class="form_item_button form_item_button-blue" @click="hidePop">Закрити</a></div>
                </div>
            </div>
        </div>
    </div>
    <div class="form_item form_item-w form_item-button">
        <a class="form_item_button" @click="showPop">Архів погоди за минулі роки</a>
    </div>
</div>
</template>

<script>
export default {
    name: "WeatherArchiveComponent",
    props: {
        historicalData: Object,
        limitsData: Object,
    },

    mounted() {
        //console.log('mounted');
    },

    data: function () {
        return {
            popShown: false,
        };
    },

    computed: {
        years() {
            return Object.keys(this.historicalData);
        },

        heatDaysCount() {
            let heatDaysCount = [];

            for (let chartYear of this.years) {
                let countOfHeatDayPerYear = 0;
                for(let dataItem of this.historicalData[chartYear].data) {
                    if(dataItem.heat >= this.limitsData.HD.threshold) {
                        countOfHeatDayPerYear++;
                    }
                }
                heatDaysCount.push(countOfHeatDayPerYear);
            }
            return heatDaysCount;
        },

        precipitationAmount() {
            let drought = [];

            for (let chartYear of this.years) {
                let droughtSum = 0;
                for(let dataItem of this.historicalData[chartYear].data) {
                    if(dataItem.precipitation > 2) {
                        droughtSum += parseFloat(dataItem.precipitation);
                    }

                    if(dataItem.precipitation === 2){
                        droughtSum += parseFloat(d[k].precipitation);
                    }
                }
                drought.push(droughtSum);
            }
            return drought;
        },

        heatDaysLimit() {
            return this.limitsData.HD.value;
        },

        heatTemperatureLimit() {
            return this.limitsData.HD.threshold;
        },

        draughtRainLimit() {
            return this.limitsData.DR.value;
        },

        xRainLimit() {
            return this.limitsData.XR.value;
        }
    },

    methods: {
        showPop() {
            this.popShown = true;
            console.log(this.preparedHistoricalData());
            this.$forceUpdate();
        },

        hidePop() {
            this.popShown = false;
        },

        preparedHistoricalData() {
            let preparedData = {};

            for (let year of this.years) {
                for(let dataItem of this.historicalData[year]['data']) {
                    let date = dataItem['date'].split('-')[1] + '/' + dataItem['date'].split('-')[2];

                    if(!preparedData.hasOwnProperty(date)) {
                        preparedData[date] = {};
                    }

                    preparedData[date][year] = {heat: dataItem['heat'], precipitation: dataItem['precipitation']};
                }
            }
            console.log(preparedData);
            return preparedData;
        },
    }
}
</script>

<style scoped>

</style>
